import AdminInner from "../../../../components/layout/admin_inner";
import {useApiManager} from "../../../../components/utils/api";
import {AggregatedBudgetStats, BudgetRestControllerApiFactory, ManagerStats, OrganizationUnitStats} from "arteco-api-client-ts";
import React, {useEffect, useState} from "react";
import {OrganizationUnits} from "./organization_units";
import {BillHomePage} from "./bill_home";
import {EfficiencyIndicators} from "../../../employee/productivity/emp_productivity_cads";
import {EmpProductivityChart} from "../../../employee/productivity/emp_productivity_chart";
import {EmpProductivityBudgets} from "../../../employee/productivity/emp_productivity_budgets";

export function OverviewPage() {
	const apiManager = useApiManager();
	const budgetCtrl = apiManager.factory(BudgetRestControllerApiFactory);
	const [budgetSummaries, setBudgetSummaries] = useState<AggregatedBudgetStats | undefined>(undefined);
	const [productivity, setProductivity] = useState<ManagerStats | undefined>(undefined);
	const [unitsSummaries, setUnitsSummaries] = useState<OrganizationUnitStats | undefined>(undefined);

	useEffect(() => {
		apiManager.execute(budgetCtrl.managerStatsBudget(undefined))
		.then(resp => setProductivity(resp))

		apiManager.execute(budgetCtrl.getActiveSummariesBudget())
		.then(resp => setBudgetSummaries(resp))

		apiManager.execute(budgetCtrl.getUnitStatsBudget(undefined))
		.then(resp => setUnitsSummaries(resp))
	}, []);

	return (
		<>
			<AdminInner title={"Visión general"}>
				{productivity && (
					<>
						<EfficiencyIndicators stats={productivity}/>
						<EmpProductivityChart stats={productivity}/>
						<EmpProductivityBudgets stats={productivity}/>
					</>
				)}

				<OrganizationUnits data={unitsSummaries}/>
				<BillHomePage/>
			</AdminInner>
		</>
	)
}